import type { ReportingComparison } from '../../../types/reporting';

const ROLLING_7_DAY_PRESETS = new Set(['wtd', 'last_7_days']);
const ROLLING_PRESETS = new Set([
    'last_14_days',
    'last_30_days',
    'last_3_months',
    'last_6_months',
    'last_year',
]);

/** API comparison object sent with reporting requests (derived from preset). */
export function getReportingComparison(preset: string | undefined): ReportingComparison | undefined {
    if (!preset || preset === 'custom') return undefined;
    if (ROLLING_7_DAY_PRESETS.has(preset)) {
        return { mode: 'rolling', offsetDays: 7 };
    }
    if (preset === 'this_month') {
        return { mode: 'calendar', period: 'month' };
    }
    if (preset === 'this_quarter') {
        return { mode: 'calendar', period: 'quarter' };
    }
    if (ROLLING_PRESETS.has(preset)) {
        return { mode: 'rolling' };
    }
    return undefined;
}

/** Preset ranges that send comparison to the API (excludes user-picked custom dates). */
export function isReportingComparisonSupported(preset: string | undefined): boolean {
    return getReportingComparison(preset) !== undefined;
}
